module.exports = __webpack_public_path__ + "static/media/8 box.3801bd03.svg";